import PropTypes from "prop-types";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import RegionForm from "routes/regions/forms/RegionForm";

const HEADER = "Edit Region";

const EditRegionModal = ({ id, open, onOpenChange, onSuccess }) => {
  const handleSuccess = async () => {
    onOpenChange(false);
    await onSuccess();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>{HEADER}</DialogTitle>
        <RegionForm
          id={id}
          onSuccess={handleSuccess}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

EditRegionModal.propTypes = {
  id: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
};

export default EditRegionModal;
